import Link from "next/link";
import { useTranslations } from "next-intl";

import { NotificationRow } from "@/components/doc/left-sidebar/top-menu/notifications/NotificationRow";
import { teamPageUrl } from "@/urls";

import type { MembershipWithTeam, Notification } from "@/api";

export function MembershipNotificationItem({
  notification,
  entity,
}: {
  notification: Notification;
  entity: MembershipWithTeam;
}) {
  const t = useTranslations("sidebar.notifications");

  return (
    <NotificationRow notification={notification} eventType="membership">
      <p className="text-[15px] leading-[18px] tracking-[-0.02em]">
        {t.rich("membership.body", {
          senderName: notification.sender.name,
          name: entity.entity.title ?? "",
          accessLevel: entity.accessLevel,
          user: (chunks) => (
            <Link
              href={teamPageUrl({ teamPermalink: notification.sender.username })}
              className="font-semibold hover:underline"
            >
              {chunks}
            </Link>
          ),
          team: (chunks) => (
            <Link
              href={teamPageUrl({ teamPermalink: entity.entity.permalink })}
              className="font-semibold hover:underline"
            >
              {chunks}
            </Link>
          ),
        })}
      </p>
    </NotificationRow>
  );
}
